export /* eslint-env es2020 */
function parseAssetString(assetStr) {
  // "1.2345 XPR" -> { amountInt: BigInt(12345), precision: 4, symbol: "XPR" }
  const s = String(assetStr || "").trim();
  if (!s) return null;
  const parts = s.split(/\s+/);
  if (parts.length < 2) return null;
  const qty = parts[0];
  const symbol = parts[1];
  const [a, b = ""] = qty.split(".");
  if (!/^-?\d+$/.test(a) || !/^\d*$/.test(b)) return null;
  const precision = b.length;
  const sign = a.startsWith("-") ? -1n : 1n;
  const ai = BigInt(a.replace("-", ""));
  const bi = BigInt((b + "0".repeat(precision)).slice(0, precision) || "0");
  const scale = BigInt("1" + "0".repeat(precision));
  const amountInt = (ai * scale + bi) * sign;
  return { amountInt, precision, symbol };
}

export function symbolCodeFrom(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const parts = s.split(",");
  return String(parts[parts.length - 1] || "").trim().toUpperCase();
}

export function parseSymbolParts(rawSymbol) {
  // Accept "4,XPR" or "XPR" (best-effort). Returns { precision, symbol }.
  const s = String(rawSymbol || "").trim();
  if (!s) return { precision: 4, symbol: "" };
  if (s.includes(",")) {
    const [p, sym] = s.split(",", 2);
    const precision = Number(String(p || "").trim());
    const symbol = String(sym || "").trim().toUpperCase();
    return { precision: Number.isFinite(precision) ? precision : 4, symbol };
  }
  // If precision is unknown, default to 4 (common on XPR); symbol is the code.
  return { precision: 4, symbol: symbolCodeFrom(s) || s.toUpperCase() };
}

export function assetPlaceholderForSymbol(rawSymbol) {
  const { precision, symbol } = parseSymbolParts(rawSymbol);
  if (!symbol) return "0.0000 SYMBOL";
  return `0.${"0".repeat(Math.max(0, precision))} ${symbol}`;
}

export function amountPlaceholderForSymbol(rawSymbol) {
  // Returns only the numeric part (without symbol) for input placeholders
  // e.g. for "4,XPR" returns "0.0000" (not "0.0000 XPR")
  const { precision } = parseSymbolParts(rawSymbol);
  return `0.${"0".repeat(Math.max(0, precision))}`;
}

export function normalizeAssetInputForSymbol(input, rawSymbol) {
  const s = String(input || "").trim();
  const { precision, symbol } = parseSymbolParts(rawSymbol);
  if (!s) return "";
  // If user already typed an asset string, keep it.
  if (s.includes(" ")) return s;
  // If user typed only a number, format it.
  if (!/^-?\d+(\.\d+)?$/.test(s)) return s;
  const [w, f = ""] = s.split(".");
  const frac = (f + "0".repeat(precision)).slice(0, precision);
  return `${w}.${frac} ${symbol}`;
}

export function formatAssetInt(amountInt, precision, symbol) {
  const neg = amountInt < 0n;
  const abs = neg ? -amountInt : amountInt;
  const scale = BigInt("1" + "0".repeat(precision));
  const whole = abs / scale;
  const frac = abs % scale;
  const fracStr = frac.toString().padStart(precision, "0");
  return `${neg ? "-" : ""}${whole.toString()}.${fracStr} ${symbol}`;
}

export function remainingAssetString(dep) {
  const a = parseAssetString(dep?.amount);
  const c = parseAssetString(dep?.claimed);
  if (!a || !c || a.symbol !== c.symbol || a.precision !== c.precision) return "";
  const rem = a.amountInt - c.amountInt;
  return formatAssetInt(rem, a.precision, a.symbol);
}
